// base urls
const s3BucketBaseUrl =
  "https://hiring-assistant-assets.s3.ap-south-1.amazonaws.com";
const consoleBaseUrl =
  process.env.REACT_APP_CONSOLE_BASE_URL || "https://console.qualifyme.ai";

// Assets
const assessmentPageImage = `${s3BucketBaseUrl}/assessment-screen.png`;
const listingPageImage = `${s3BucketBaseUrl}/job-post-listing-screen.png`;
const detailsPageImage = `${s3BucketBaseUrl}/requirements-screen.png`;
const profileMatchPageImage = `${s3BucketBaseUrl}/ai-resume-match-screen.png`;
const onlineInterviewPageImage = `${s3BucketBaseUrl}/slot-selection-screen.png`;
const applicationFlowVideo = `${s3BucketBaseUrl}/application-flow.mp4`;

// How to start ai assessment docs
const howToStartAiAssessmentVideoChrome = `${s3BucketBaseUrl}/Assessment-start-guide-default.mp4`;
const howToStartAiAssessmentVideoChromeManual = `${s3BucketBaseUrl}/Assessment-start-guide-manual-setup.mp4`;
const howToStartAiAssessmentPdfChrome = `${s3BucketBaseUrl}/Assessment-start-guide-default.pdf`;
const howToStartAiAssessmentPdfChromeManual = `${s3BucketBaseUrl}/Assessment-start-guide-manual-setup.pdf`;

// Support Emails
const qualifymeSupportEmail = "support@qualifyme.ai";

export {
  // base urls
  s3BucketBaseUrl,
  consoleBaseUrl,

  // Assets
  assessmentPageImage,
  listingPageImage,
  detailsPageImage,
  profileMatchPageImage,
  onlineInterviewPageImage,
  applicationFlowVideo,

  // How to start ai assessment docs
  howToStartAiAssessmentVideoChrome,
  howToStartAiAssessmentVideoChromeManual,
  howToStartAiAssessmentPdfChrome,
  howToStartAiAssessmentPdfChromeManual,

  // Support Emails
  qualifymeSupportEmail,
};
